import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { BaseNotebookCellButtonComponent } from '../base-button.component';

@Component({
  selector: 'mode-notebook-included-report-cell-button',
  templateUrl: './notebook-included-report-cell-button.component.html',
  styleUrls: ['./notebook-included-report-cell-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotebookIncludedReportCellButtonComponent extends BaseNotebookCellButtonComponent implements OnChanges {
  @Input()
  state = false;

  @Input()
  disabled = false;

  @Output()
  toggle: EventEmitter<{ cellToken: string; inLayout: boolean }> = new EventEmitter();

  buttonText = '';

  constructor() {
    super();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes['state']) {
      this.buttonText = changes['state'].currentValue ? 'Remove from Report' : 'Add to Report';
    }
  }

  toggleReportState() {
    this.toggle.emit({ cellToken: this.cellToken, inLayout: this.state });
  }
}
